
import { Component, Prop } from "vue-property-decorator";
import ListComponent from "@/app/shared/components/generic/list/ListComponentV2.vue";
import moment from "moment";
import "moment/locale/fr";
// eslint-disable-next-line no-unused-vars
import preparationControl from "../../../PreparationControl.vue";
// eslint-disable-next-line no-unused-vars
import preparationControlController from "../../../shared/services/controllers/preparationControl/preparationControlController";
// eslint-disable-next-line no-unused-vars
import { TypeControle } from "../../../shared/store/Types";

moment.locale("fr");

const moduleName = "preparationControl";

@Component
export default class ByPlan extends ListComponent {
  @Prop() declare controller: preparationControlController;
  @Prop() dateControle!: string;
  @Prop() typeControle!: TypeControle;

  onRowClicked = "";
  onRowDoubleClicked = "";

  async onGridReady(params: any) {
    let gridApi = params.api;

    this.dataSource = {
      rowCount: null,
      getRows: async (params: any) => {
        let query = this.fillListWithFilterAndSort(params);

        this.controller.Log.logDebug(`listPreparationControlByPlan`, `Object query : ${JSON.stringify(query)}`);
        let sendResult: { data: any[]; itemsCount: number } | null = { data: [], itemsCount: 0 };

        try {
          if (this.dateControle && this.typeControle) {
            sendResult = await this.controller.preparationControlStore.getLst(this.dateControle, this.typeControle, query);
            // Affichage du DO et transporteur = Code + Nom dans la grille
            sendResult?.data.forEach(function (element) {
              var code = element.carrierCode != null ? element.carrierCode + " - " : "";
              var name = element.carrierName != null ? element.carrierName : "";
              element.carrier = `${code}${name} `;
            });
          }

          params.successCallback(sendResult?.data, sendResult?.itemsCount);
        } catch (error) {
          //Log
          await this.controller.Log.logError(`listPreparationControlByPlan onGridReady`, "", error, moduleName);
          sendResult = null;
        }
      },
    };
    gridApi.setDatasource(this.dataSource);
  }

  /**
   * rafraichissement de la liste
   */
  refreshList() {
    this.refreshData();
  }

  onRowSelected(row: any) {
    if (row.node.isSelected()) {
      (this.$parent as preparationControl).current_step = 2;
      (this.$parent as preparationControl).plan = row.data;
    }
  }

  async beforeMount() {
    this.columnDefs = [
      this.numericColumn("id", {
        headerName: "Id",
        hide: true,
        cellRenderer: this.gridOptions.components.loadingRenderer,
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
      }),
      this.textColumn("number", {
        headerName: "N° de plan",
        field: "number",
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
        floatingFilterComponentParams: { suppressFilterButton: false },
        width: 80,
      }),
      this.textColumn("carrier", {
        headerName: "Transporteur",
        field: "carrier",
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
        floatingFilterComponentParams: { suppressFilterButton: false },
      }),
      this.textColumn("licensePlate", {
        headerName: "Immatriculation",
        field: "licensePlate",
        hide: true,
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
        floatingFilterComponentParams: { suppressFilterButton: false },
      }),
      this.textColumn("weeklyDeliveryPlanning", {
        headerName: "Code cadencier",
        field: "weeklyDeliveryPlanning",
        hide: true,
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
        floatingFilterComponentParams: { suppressFilterButton: false },
      }),
      this.textColumn("loadingPlanCarrierNumber", {
        headerName: "N° plan transporteur",
        field: "loadingPlanCarrierNumber",
        hide: true,
        suppressMenu: true,
        floatingFilter: false,
        sortable: false,
        floatingFilterComponentParams: { suppressFilterButton: false },
      }),
    ];

    //this.gridOptions.rowSelection = "multiple";
    this.gridOptions.rowMultiSelectWithClick = true;

    //modification pour permettre l'infiniteScrolling
    this.pagination = true;
    this.gridOptions.infiniteInitialRowCount = 20;
    this.gridOptions.maxBlocksInCache = 20;
    this.gridOptions.cacheOverflowSize = 20;
    this.gridOptions.maxConcurrentDatasourceRequests = 5;

    // on conditionne le nombre de ligne affiché en fonction du device
    if (this.$vuetify.breakpoint.smAndDown) {
      this.gridOptions.paginationPageSize = 5;
      this.pagination = true;
    } else {
      this.gridOptions.paginationPageSize = 20;
    }

    this.gridOptions.cacheBlockSize = 20;

    // Suppression des boutons clear filtre
    this.clearFilterButtonVisibility = false;
  }

  mounted() {
    (this.$parent as preparationControl).clearCabAndPlan();
    (this.$parent as preparationControl).refreshListPallets();
  }
}
